// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"dA-z","smallCardRow":"eA-z","largeCardRow":"fA-z","productSearchRow":"gA-z","curatedRow":"hA-z"};